// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"83293737","560":"83293737","673":"5c1970aa","760":"bc643cd4","965":"83293737"}[chunkId] + ".chunk.css";
};